var map = {
	"./calendar.webp": 1524,
	"./cash.webp": 1525,
	"./check-in-title-bg.webp": 1526,
	"./coin.webp": 1527,
	"./current-check-in-container.webp": 1528,
	"./current-last-day-check-in-container.webp": 1529,
	"./daily-check-in-bg.webp": 1530,
	"./default-check-in-container.webp": 1531,
	"./giftbox.webp": 1532,
	"./golden-coin.webp": 1533,
	"./halfweek-check-in-container.webp": 1534,
	"./last-day-check-in-container.webp": 1535,
	"./missed-checkIn.webp": 1536,
	"./more-cash.webp": 1537,
	"./more-coin.webp": 1538,
	"./more-spin.webp": 1539,
	"./need-deposit.webp": 1540,
	"./present.webp": 1541,
	"./reward-coin.webp": 1542,
	"./shine.webp": 1543,
	"./silver-coin.webp": 1544,
	"./spin.webp": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;